<template>
    <div>
        <MainHeader />

        <b-container fluid class="p-3 p-md-4 p-lg-5">
            <b-card-group deck>
                <b-card
                title="Création d'entreprise"
                :img-src="services.creation.img"
                img-alt="Tour Eiffel"
                img-top
                >
                    <b-card-text>
                        Créez votre entreprise à l'aide des services Assistel
                    </b-card-text>

                    <b-button to="/creation/accueil" variant="primary" size="lg">Créer mon entreprise</b-button>
                </b-card>

                <b-card
                title="Domiciliation d'entreprise"
                :img-src="services.domiciliation.img"
                img-alt="Louvre de Paris"
                img-top
                >
                    <b-card-text>
                        Domiciliez votre entreprise à l'une de nos adresses à Paris.
                    </b-card-text>

                    <b-button to="/domiciliation/accueil" variant="primary" size="lg">Domicilier mon entreprise</b-button>
                </b-card>
            </b-card-group>
        </b-container>

        <Sidebar />

        <MainFooter />
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import MainHeader from '../components/MainHeader.vue'
    import Sidebar from '../components/Sidebar.vue'
    import MainFooter from '../components/MainFooter.vue'

    export default {
        components: {
            MainHeader,
            Sidebar,
            MainFooter
        },
        computed: {
            ...mapState(['services'])
        }
    }
</script>
